export default __webpack_public_path__ + "locales/vi/Common.json?hash=306d1969ee021d183ffc01d779a33a48";